<script setup lang="ts">
import { ref, computed } from 'vue'
import { useTaskProfiles } from '../../store/useTaskProfiles'
import FormBulkUpdateRai from './FormBulkUpdateRai.vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useTimers } from '../../store/timers'
const props = defineProps<{
  tasks: any
}>()
const emit = defineEmits<{
  (e: 'setBulkRaiFilter'): void
  (e: 'bulkDataChange'): void
}>()
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`form.${key}`)
const { updateRAI, triggerTaskDataRef } = useTaskProfiles()
const { getActiveChildTimer } = storeToRefs(useTimers())
const bulkUpdateRai = ref(false)
const taskIds = computed(() => (props.tasks ? props.tasks.map((task: any) => task.task_id) : []))
const updateRaiCodes = async (
  data: { rai_code: any; rai_reason_code: any },
  tasksToUpdate: any[]
) => {
  if (tasksToUpdate.length > 0) {
    //compare against now, but strip out time
    const today = new Date()
    today.setUTCHours(0, 0, 0, 0)
    for (const task of tasksToUpdate) {
      const taskStartDate = new Date(task.task_start_date)
      taskStartDate.setUTCHours(0, 0, 0, 0)
      if (
        today.getTime() >= taskStartDate.getTime() &&
        String(getActiveChildTimer.value?.data.task_id) !== String(task.task_id) // Don't bulk update the task if it's currently in-progress
      ) {
        //update rai code, let task profile store handle undefined reason code
        await updateRAI(
          task.task_id as string,
          data.rai_code.code,
          data.rai_reason_code?.code,
          true
        )
      }
    }
    //trigger ref update and save data
    await triggerTaskDataRef()
  }

  //tell parent component
  emit('bulkDataChange')
}
const setBulkRaiFilter = () => {
  emit('setBulkRaiFilter')
  bulkUpdateRai.value = false
}
</script>
<template>
  <q-btn color="secondary" :label="label('updateStatus')" @click="bulkUpdateRai = true" />
  <FormBulkUpdateRai
    v-model="bulkUpdateRai"
    :checked-task-ids="taskIds"
    @update-rai-code="updateRaiCodes($event, tasks)"
    @set-bulk-rai-filter="setBulkRaiFilter"
  />
</template>
